import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BusinessPartner } from '../../model/business_partner';
import { BusinessPartnerSelector } from '../../common/components/business-partner-selector/business-partner-selector';

@Component({
  selector: 'app-add-user-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, BusinessPartnerSelector],
  templateUrl: './add-user-dialog.html',
  styleUrl: './add-user-dialog.css'
})
export class AddUserDialog {
  @Output() closed = new EventEmitter<void>();
  @Output() submitUser = new EventEmitter<{
    name: string;
    lastName: string;
    email: string;
    businessPartner: BusinessPartner;
    password: string;
  }>();
  @Input() submitting: boolean = false;

  name: string = '';
  lastName: string = '';
  email: string = '';
  businessPartner: BusinessPartner = {
    Id: 1,
    ParentId: null,
    Name: '',
    LastName: '',
    Phone: '',
    Email: '',
    CompanyName: 'FleetBooster',
    Level: 0,
    Enabled: true,
    CreatedBy: null,
    CreatedDate: null
  };
  password: string = '';
  confirmPassword: string = '';

  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  onBusinessPartnerChange(bp: BusinessPartner | null): void {
    if (bp) {
      this.businessPartner = bp;
    }
  }

  get emailValid(): boolean {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(this.email).toLowerCase());
  }

  get passwordsMatch(): boolean { return this.password === this.confirmPassword; }
  get passwordValid(): boolean { return this.password.length >= 8; }
  get formValid(): boolean {
    return !!this.name && !!this.lastName && this.emailValid && !!this.businessPartner && !!this.businessPartner.Id && this.passwordValid && this.passwordsMatch;
  }

  onCancel(): void { this.closed.emit(); }
  onSubmit(): void {
    if (!this.formValid) return;
    this.submitUser.emit({
      name: this.name,
      lastName: this.lastName,
      email: this.email,
      businessPartner: this.businessPartner,
      password: this.password
    });
  }
}


